module.exports = __webpack_public_path__ + "img/no_network.9d2c0298.png";